import React from 'react';
type CtaButtonProps = {
  href?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  size?: 'lg' | 'md';
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
};
export function CtaButton({
  href,
  disabled,
  fullWidth,
  size = 'lg',
  className = '',
  onClick,
  children
}: CtaButtonProps) {
  const sizes = size === 'lg' ? `px-6 py-[17px] text-[22px] sm:px-9 sm:py-5 sm:text-[26px] ${className}` : `px-5 py-3 text-lg shadow-[0_5px_0_#8E3526] ${className}`;
  const classes = `inline-flex items-center justify-center gap-3 rounded-2xl bg-coral font-display font-bold uppercase tracking-[.01em] text-white no-underline shadow-[0_7px_0_#8E3526] transition-[background-color,transform,box-shadow] duration-150 ease-out ${sizes} ${fullWidth ? 'w-full' : ''} ${disabled ? 'cursor-not-allowed opacity-60' : 'hover:bg-coral-hover active:translate-y-[5px] active:shadow-[0_2px_0_#8E3526]'}`;
  if (href && !disabled) {
    return <a href={href} className={classes} onClick={onClick} data-id="element-237" data-mp="2hgbgt2oejuqi">
        {children}
      </a>;
  }
  return <button type="button" disabled className={classes} data-id="element-238" data-mp="2cijdlcib4m70">
      {children}
    </button>;
}